
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referralcandy-alternative",
      function () {
        return require("private-next-pages/referralcandy-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referralcandy-alternative"])
      });
    }
  